import { Address } from '@31third/common';
import { Chain, ChainToken, ChainTokenCheck } from '../model';
import { ChainTokenDto } from '../dto';
import { ChainFactory } from './chain.factory';
import { ChainTokenCheckFactory } from './chain-token-check.factory';

export class ChainTokenFactory {
  public static createChainTokenFromDto(
    chainTokenDto: ChainTokenDto,
  ): ChainToken {
    return this.createChainToken(
      chainTokenDto.id,
      chainTokenDto.address,
      ChainFactory.createChainFromDto(chainTokenDto.chain),
      chainTokenDto.enabled,
      chainTokenDto.automationEnabled,
      chainTokenDto.nativeToken,
      chainTokenDto.maxWeiImprecision,
      chainTokenDto.tradeable,
      chainTokenDto.checkedManually,
      chainTokenDto.enzymeAsset,
      chainTokenDto.autoCreated,
      ChainTokenCheckFactory.createFromDtos(chainTokenDto.checks),
    );
  }

  public static createChainToken(
    id: string,
    address: Address,
    chain: Chain,
    enabled: boolean,
    automationEnabled: boolean,
    nativeToken: boolean,
    maxWeiImprecision: number,
    tradeable: boolean,
    checkedManually: Date,
    enzymeAsset: boolean,
    autoCreated: boolean,
    checks: ChainTokenCheck[],
  ): ChainToken {
    const chainToken = new ChainToken();
    chainToken.id = id;
    chainToken.address = address;
    chainToken.chain = chain;
    chainToken.enabled = enabled;
    chainToken.automationEnabled = automationEnabled;
    chainToken.nativeToken = nativeToken;
    chainToken.maxWeiImprecision = maxWeiImprecision;
    chainToken.tradeable = tradeable;
    chainToken.checkedManually = checkedManually;
    chainToken.enzymeAsset = enzymeAsset;
    chainToken.autoCreated = autoCreated;
    chainToken.checks = checks;
    return chainToken;
  }
}
